import { createRouteRef, createSubRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'organisations',
});

export const organisationDetailsRouteRef = createSubRouteRef({
  id: "details",
  parent: rootRouteRef,
  path: '/:org_id',
});